import { Routes, Route } from 'react-router-dom';
import Home from './routes/home/home.route';
import NavBar from './routes/navbar/navbar.route';
import BookNow from './routes/book-now/book-now.route';


const Info = () => {
  return (
    <div>Info page</div>
  );
}

const App = () => {
  return (
    <Routes>
      <Route path='/' element={<NavBar />}>
        <Route index element={<Home />} />
        <Route path='book-now' element={<BookNow />} />
      </Route>
    </Routes>
  );
}

export default App;
